// Purpose: Blob-download HTTP helper — used for streaming .xlsx, .pdf, etc. direct from server
// Caller: Service layers that need blob responses (exportInouts, etc.)
// Dependencies: constant (apiURL)
// Side Effects: Reads localStorage (accessToken), no JSON parsing

import { apiURL } from 'constant'

export async function fetchBlob(path, { method = 'GET', query, body, timeout = 60000 } = {}) {
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), timeout)

  const accessToken = localStorage.getItem('accessToken')
  const headers = {}
  if (accessToken) headers['Authorization'] = accessToken

  let url = `${apiURL}${path}`
  if (query) {
    const params = new URLSearchParams()
    for (const [k, v] of Object.entries(query)) {
      if (v != null && v !== '') {
        params.append(k, typeof v === 'object' ? JSON.stringify(v) : v)
      }
    }
    const qs = params.toString()
    if (qs) url += '?' + qs
  }

  if (body && method !== 'GET') {
    headers['Content-Type'] = 'application/json'
  }

  try {
    const res = await fetch(url, {
      method,
      headers,
      body: body && method !== 'GET' ? JSON.stringify(body) : undefined,
      signal: controller.signal,
    })
    return res
  } finally {
    clearTimeout(timer)
  }
}
